import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { bindActionCreators } from 'redux';
import isEqual from 'lodash/isEqual';

import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as HoldActions from '../actions/HoldActions';
import { currentUserSelector, currentAccountSelector } from '../selectors/AuthSelector';
import AvailabilityDetailActions from '../actions/AvailabilityDetailActions';
import { currentLibrarySelector, sortedPickupBranchSelector } from '../selectors/LibrarySelector';
import { getShelfTransactions, getShelvesForCurrentUser } from '../selectors/ShelfSelector';
import BasePageContainer from './BasePageContainer';

import {
  getCurrentHolds,
  getCountsByStatus,
  getMaterialTypeCounts,
  getSelectedStatus,
  getPresentStatuses,
  getHoldsQuotas,
  getPagination,
  getHoldsTransactions,
  getHoldsStatus
} from '../selectors/HoldsSelector';
import WorkflowActions from '../actions/WorkflowActions';
import ShelfActions from '../actions/ShelfActions';
import Holds from '../components/borrowing/holds/Holds';
import * as BorrowingActions from '../actions/BorrowingActions';
import DocumentHeadContainer from './DocumentHeadContainer';

export class HoldsContainer extends BasePageContainer {
  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [
      store.dispatch(BorrowingActions.fetchSummaries({ accountId })),
      store.dispatch(HoldActions.fetchHolds({ accountId, ...params, ...query }))
    ];
  }

  static getBackToTitleKey() {
    return 'holds';
  }

  componentDidMount() {
    super.componentDidMount();

    const { accountId, location, router } = this.props;
    this.props.holdActions.fetchHolds({ accountId, ...router.params, ...location.query });
  }

  componentWillUpdate(nextProps) {
    const { location, items } = this.props;

    const locationChanged = !isEqual(location, nextProps.location);
    const itemsChanged = !isEqual(items, nextProps.items);

    if (locationChanged || itemsChanged) {
      this.props.holdActions.fetchHolds({
        accountId: nextProps.accountId,
        ...nextProps.router.params,
        ...nextProps.location.query
      });
    }
  }

  render() {
    const pageTitle = this.props.intl.formatMessage({ id: 'section_title_holds' });
    return (
      <div>
        <DocumentHeadContainer pageTitle={pageTitle} />
        <Holds {...this.props} />
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const countsByStatus = getCountsByStatus(state);
  const user = currentUserSelector(state);
  const items = getCurrentHolds(state, ownProps);
  const materialTypeCounts = getMaterialTypeCounts(state, ownProps);
  const selectedStatus = getSelectedStatus(state, ownProps);
  const presentStatuses = getPresentStatuses(state, ownProps);
  const quotas = getHoldsQuotas(state, ownProps);
  const library = currentLibrarySelector(state);
  const featuredListTypes = library.get('featuredListTypes', Immutable.List());
  const showStaffPicksLink = featuredListTypes && featuredListTypes.includes('staff_picks');
  const branches = sortedPickupBranchSelector(state, ownProps);
  const accountId = currentAccountSelector(state).get('id');
  const availabilityDetail = state.get('availabilityDetail');
  const pagination = getPagination(state, ownProps);
  const holdsTransactions = getHoldsTransactions(state);
  const shelves = getShelvesForCurrentUser(state);
  const shelfTransactions = getShelfTransactions(state);
  const holdsStatus = getHoldsStatus(state);

  return {
    user,
    items,
    totalUnfilteredCount: selectedStatus ? countsByStatus.get(selectedStatus) : pagination.get('count', 0),
    materialTypeCounts,
    selectedStatus,
    presentStatuses,
    quotas,
    showStaffPicksLink,
    branches,
    accountId,
    availabilityDetail,
    pagination,
    holdsTransactions,
    shelves,
    shelfTransactions,
    fetching: holdsStatus.get('fetching', false)
  };
};

const mapDispatchToProps = dispatch => ({
  holdActions: bindActionCreators(HoldActions, dispatch),
  workflowActions: bindActionCreators(WorkflowActions, dispatch),
  availabilityDetailActions: bindActionCreators(AvailabilityDetailActions, dispatch),
  shelfActions: bindActionCreators(ShelfActions, dispatch),
  borrowingActions: bindActionCreators(BorrowingActions, dispatch)
});


HoldsContainer.propTypes = {
  intl: intlShape,
  pagination: ImmutablePropTypes.map,
  holdsActionItems: ImmutablePropTypes.map,
  shelves: ImmutablePropTypes.map,
  shelfTransactions: ImmutablePropTypes.map,
  fetching: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(HoldsContainer));



// WEBPACK FOOTER //
// ./app/containers/HoldsContainer.jsx